import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoicepage',
  templateUrl: './invoicepage.component.html',
  styleUrls: ['./invoicepage.component.scss']
})
export class InvoicepageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
